import { configureStore } from '@reduxjs/toolkit';

import { CityQuery } from '@/Module/Auth/Store/Query/CityQuery';
import { ProvinceQuery } from '@/Module/Auth/Store/Query/ProvinceQuery';
import { ReferQuery } from '@/Module/Auth/Store/Query/ReferQuery';
import { ENV } from '@/Module/Core/Constant';
import { EnvType } from '@/Module/Core/Model/Enum';
import { CampaignQuery, StatisticsQuery } from '@/Module/DefaultLayout/Store/Query';
import { CategoryListQuery } from '@/Module/Grade/Store/Query/CategoryListQuery';
import { QuestionTypeQuery } from '@/Module/Question/Store/Query/QuestionTypeQuery';
import rootReducer from '@/Module/Store/Helper/rootReducer';

const makeStore = () =>
  configureStore({
    reducer: rootReducer,
    devTools: ENV === EnvType.DEVELOP,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware()
        .concat(ProvinceQuery.middleware)
        .concat(CityQuery.middleware)
        .concat(ReferQuery.middleware)
        .concat(QuestionTypeQuery.middleware)
        .concat(CategoryListQuery.middleware)
        .concat(CampaignQuery.middleware)
        .concat(StatisticsQuery.middleware),
  });

export type IMakeStoreType = ReturnType<typeof makeStore>;

export default makeStore;
